export enum Rarity {
  COMMON = "common",
  UNCOMMON = "uncommon",
  RARE = "rare",
  EPIC = "epic",
  LEGENDARY = "legendary",
}

export enum DegenerateType {
  NONE = "none",
  ANAGRAM = "anagram",
  PARTIAL_ANAGRAM = "partial",
  REPEATED_DIGITS = "repeated",
  NEAR_SOLUTION = "near",
}

export enum PowerUpTier {
  BOOST = "boost",
  SURGE_I = "surge_i",
  SURGE_II = "surge_ii",
  ORACLE = "oracle",
}

export interface Hint {
  readonly digits: readonly number[];
  readonly correct_placed: number;
  readonly correct_misplaced: number;
}

export interface ScoredHint {
  readonly hint: Hint;
  readonly rarity: Rarity | null;
  readonly elimination_rate: number;
  readonly percentile: number;
  readonly degenerate_type: DegenerateType;
  readonly power_up: PowerUpTier | null;
  readonly candidates_before: number;
  readonly candidates_after: number;
  readonly distinct_digits_tested: number;
  readonly unique_correct_digits: number;
}

export interface RoomModifier {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly minRoom: number;
}

export interface RoomConfig {
  readonly codeLength: number;
  readonly baseHintTarget: number;
  readonly modifier: RoomModifier;
  readonly reserveCount: number;
  readonly roomNumber: number;
}

export interface GhostHint {
  readonly digits: readonly number[];
  readonly correct_placed: number;
  readonly correct_misplaced: number;
  readonly rarity: string;
  readonly isGhost: true;
}

export interface LootItem {
  readonly digits: readonly number[];
  readonly correct_placed: number;
  readonly correct_misplaced: number;
  readonly lootType: string;
  readonly power_up: string;
  readonly degenerate_type: string;
}

export interface Room {
  readonly solution: readonly number[];
  readonly baseHints: readonly ScoredHint[];
  readonly reserveHints: readonly ScoredHint[];
  readonly roomPowerUps: readonly ScoredHint[];
  readonly isUnique: boolean;
  readonly optimalSize: number;
  readonly optimalIndices: readonly number[];
  readonly modifier: RoomModifier;
  readonly roomNumber: number;
  readonly codeLength: number;
  readonly hiddenHintIndex: number | null;
  readonly loot: LootItem | null;
  readonly bonusLives: number;
  readonly ghostHint: GhostHint | null;
}
